import api from "./api";

const MULTIPART = { headers: { "Content-Type": "multipart/form-data" } };

class PosStaffService {
  getList(dataForm) {
    return api.get("/merchant/pos-staff", { params: dataForm });
  }

  detail(staffId) {
    return api.get("/merchant/pos-staff/" + staffId);
  }

  /**
   * SH030 — the merchant's whole service menu, for the staff dialog's service picker.
   *
   * Merchant-wide rather than per sale channel: a stylist's skills are not per outlet,
   * so the list is fetched once when the screen loads and reused by every staff dialog
   * opened on it.
   */
  getServices() {
    return api.post("/merchant/pos-staff/services");
  }

  store(dataForm) {
    // SH008: multipart so the stylist photo can travel. Axios turns the plain object
    // into a FormData once the header says multipart, arrays included.
    return api.post("/merchant/pos-staff", dataForm, MULTIPART);
  }

  update(dataForm) {
    // SH008: posted with _method: PUT rather than sent as a real PUT. PHP does not parse
    // multipart bodies on PUT, so a genuine PUT would reach the controller with no file
    // and no fields at all — the save would look successful and change nothing.
    return api.post(
      "/merchant/pos-staff/" + dataForm.id,
      { ...dataForm, _method: "PUT" },
      MULTIPART
    );
  }
}

export default new PosStaffService();
